import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-65ea6b49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { onMounted, ref } from 'vue'
import { useAuth } from '@/store/useAuth'
import main from '@/data/main.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeMessage',
  setup(__props) {

const store = useAuth()
const user = ref()
onMounted(async () => {
    const rawResponse = await fetch(`${main.BASE_ENDPOINT}/my-user`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.token}`
        }
    })
    user.value = await rawResponse.json()
})

return (_ctx: any,_cache: any) => {
  return (user.value)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "¡Bienvenid@ al campus, " + _toDisplayString(user.value.name) + "!   Has accedido como Estudiante.", 1))
    : _createCommentVNode("", true)
}
}

})